<template>
    <div class="summary-panel">
        <table>
            <thead :class="hideBg ? '' : 'panel-bar'">
                <tr>
                    <slot class="divider" name="header"></slot>
                </tr>
            </thead>
            <tbody :class="hideBg ? '' : 'panel-body'">
                <tr v-for="(val, index) of list" v-bind:key="index">
                    <slot :name="`body${(index + 1)}`"></slot>
                </tr>
            </tbody>
        </table>
        <div class="summary-panel-info">
            <slot name="info"></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'SummaryPanel',
    props: {
        title: String,
        rowCount: Number,
        hideBg: Boolean
    },
    computed: {
        list() {
            return new Array(this.rowCount);
        }
    }
}
</script>